var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m930 480v-210h-210v90h-45c-57.891 0-105 47.109-105 105v60c0 41.344-33.656 75-75 75h-45v-90h-210v210h210v-90h45c41.344 0 75 33.656 75 75v60c0 57.891 47.109 105 105 105h45v90h210v-210h-210v90h-45c-41.344 0-75-33.656-75-75v-60c0-38.391-20.953-71.672-51.797-90 30.844-18.328 51.797-51.609 51.797-90v-60c0-41.344 33.656-75 75-75h45v90z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeIcon);
export default __webpack_public_path__ + "static/media/node-icon.5e76527f8c1818a67d133b92aefeeed3.svg";
export { ForwardRef as ReactComponent };